import axios from "../../utils/axiosConfig";
import { ProfileDTO } from "../../dtos/profile";
import decryptResponse from "../../utils/decrypt_new";

 
axios.defaults.withCredentials = true;

// const getProfile = async (clinicId: any) => {
//   const { data } = await axios.get(`/api/pharmacy/pharmacyProfile/get?clinic_id=${clinicId}`);
//   return data;
// };

const getProfile = async (pharmacyId: any) => {
  try {
    const { data } = await axios.get(`/api/pharmacy/get_profile?pharmacy_id=${pharmacyId}`);
    // Check if the response contains encryptedData and iv
    if (data?.data?.encryptedData && data?.data?.iv) {
      // Decrypt the response using decryptResponse function
      const decryptedResponse = await decryptResponse(
        data?.data?.encryptedData,
        data?.data.iv
      );

      // Return the decrypted profile data
      if (decryptedResponse) {
        return {
          pharmacy: decryptedResponse?.pharmacy,
          user: decryptedResponse?.user,
        };
      } else {
        throw new Error("Decrypted response is empty");
      }
    } else {
      throw new Error("Missing encryptedData or iv in response");
    }
  } catch (error) {
    console.error("Error fetching profile data:", error);
    throw new Error("Failed to fetch profile data");
  }
};

// const editProfile = async (profile: ProfileDTO) => {
//     const { data } = await axios.put( "/api/pharmacy/pharmacyProfile/update", profile);
//     return data;
//   };

const editProfile = async (profile: ProfileDTO) => {
  const { data } = await axios.put( "/api/pharmacy/update_profile", profile);
  return data;
};

const ProfileService = {
  getProfile,
  editProfile,
};

export default ProfileService;
